import { appItem } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
            <div className="w-48 md:w-56 shrink-0">
              <img
                src={appItem.image}
                alt="妖精动漫 APP"
                className="w-full h-auto rounded-xl object-cover"
                width={400}
                height={700}
              />
            </div>

            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100/80 text-accent-800 rounded-full mb-3 whitespace-nowrap">
                移动端专属
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{appItem.title}</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">{appItem.desc}</p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-6">
                {appItem.features.map((f, i) => (
                  <span key={i} className="px-3 py-1.5 text-xs bg-background-100 text-foreground-600 rounded-md whitespace-nowrap">
                    <i className="ri-check-line text-primary-500 mr-1" />{f}
                  </span>
                ))}
              </div>

              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即下载
                <i className="ri-download-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}